<template>
    <div class="p-3 row justify-content-center">
        <ElForm :disabled="saving" v-if="company" :model="company" label-position="top" :rules="rules" ref="formRef">
            <ElFormItem label="Nome da transportadora" prop="name">
                <ElInput name="name" v-model="company.name" />
            </ElFormItem>
            <ElFormItem label="Logotipo da empresa" prop="image">
                <img style="max-height: 250px; max-width: 100%;" :src="(company.image as string)" />
                <input type="file" name="image" @change="changeFile" />
            </ElFormItem>
            <ElFormItem label="Descricao da empres" prop="description">
                <ElInput type="textarea" name="description" v-model="company.description" />
            </ElFormItem>
            <ElFormItem label="Local" prop="area.name" v-if="company.area">
                <ElInput name="area" v-model="company.area.name" />
            </ElFormItem>
            <div style="height: 400px; width: 100%" class="position-relative">
                <el-button plain class="position-absolute end-0" style="z-index: 1024;" :loading="locating || saving" size="large" type="success" @click.prevent="locate">
                    Localizar-me
                </el-button>
                <LMap @contextmenu="onMapClick" ref="map" v-if="company.area" :zoom="16" :center="[company.area.lat, company.area.long]">
                    <LTileLayer
                        url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga"
                        layer-type="base"
                        name="OpenStreetMap"
                    ></LTileLayer>

                    <LMarker v-if="company.area" :lat-lng="[company.area.lat, company.area.long]">
                        <LTooltip>{{ company.name }}</LTooltip>
                    </LMarker>
                </LMap>
            </div>
        </ElForm>
        <el-row justify="space-between" class="py-4">
            <el-col class="col-auto">
                <el-button type="primary" @click="submit(formRef)" plain :loading="saving">
                    Salvar
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script setup lang="ts">
    import Api from '@/services/api';
    import { TravelCompany } from '@/services/types';
    import { ElForm, ElMessage, ElRow, FormInstance, FormRules, ElCol, ElInputNumber, ElInput, ElDivider, ElFormItem } from 'element-plus';
    import { reactive, ref } from 'vue';
    import { useRouter } from 'vue-router';
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip} from "@vue-leaflet/vue-leaflet"
    import { LeafletMouseEvent } from 'leaflet'
    import { toFormData } from '@/utilities/helpers';
    import { useStore } from 'vuex';

    const router = useRouter()
    const saving = ref<boolean>(false)
    const locating = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const image = ref<File | null>(null)
    const store = useStore()

    const company = reactive<TravelCompany>({
        description: '',
        image: null,
        name: '',
        area: { lat: 18.34, long: 34.18, name: '' },
        phone: null,
        password: null
    })

    const rules = ref<FormRules<TravelCompany>>({
        name: [{required: true, message: 'Preencha este campo'}],
        description: [{required: true, message: 'Preencha este campo'}],
        "area.name": [{required: true, message: 'Preencha este campo'}],
    })

    const changeFile = ({target: {files}}: any) => {
        console.log(files)
        if (files[0]) {
            image.value = files[0]
            company.image = URL.createObjectURL(files[0])
        }
    }
    
    const onMapClick = (mouseEvent: LeafletMouseEvent) => {
        const { lat, lng } = mouseEvent.latlng
        if (company.area) {
            company.area.lat = lat
            company.area.long = lng
        } else {
            company.area = {
                name: '',
                lat,
                long: lng
            }
        }
        console.log(company.area);
    }

    const locate = async () => {
        locating.value = true

        if (!navigator.geolocation) {
            alert("Geolocalização não é suportada pelo seu navegador.")
            locating.value = false
            return
        }

        navigator.geolocation.getCurrentPosition((position) => {
            if (company.area) {
                company.area.lat = position.coords.latitude
                company.area.long = position.coords.longitude
            }
            locating.value = false
        }, (err) => {
            console.log(err)
            alert("Ocorreu um erro ao tentar localizar")
            locating.value = false
        })
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!company.area?.lat || !company.area.long) {
            ElMessage.error({message: 'Por favor selecione o local no mapa'})
            return null
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const formData = toFormData(company)
                if (image.value) {
                    formData.append("image", image.value)
                }

                const res = await Api.post('/admin/travel-companies', company, formData)
                if (res.status >= 200) {
                    store.commit('setOpenModal', -1)
                    router.push('/companies/' + res.data.company.id)
                } else {
                    console.log(res)
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }
</script>